import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';
import { type FetchOffersParams } from 'services/rtk/offers/offers';
import { typedKeys } from 'utils/helpers/object';

import { initialState } from './offersPageSlice';

export const selectFiltersQuery = createSelector(
  (state: RootState) => state.offersPage,

  ({ filters, table }): Omit<FetchOffersParams, 'limit'> => ({
    page: table.page || undefined,
    sort: table.sort || undefined,
    orderBy: table.orderBy || undefined,

    search: filters.search || undefined,

    countryCode: filters.countryCode || undefined,
    type: filters.type || undefined,
    state: filters.state || undefined,
    withWarranty: filters.withWarranty,
    isDirect: filters.isDirect,
    onlyAdded: filters.onlyAdded,

    categoryId: filters.category?.id || undefined,
    affiliateId: filters.affiliate?.id || undefined,
  })
);

export const selectCanResetOffersFilters = createSelector(
  (state: RootState) => state.offersPage,
  (pageState) => {
    const { filters, table: tableState } = pageState;

    const filtersChanged = typedKeys(filters).some((key) => filters[key] !== initialState['filters'][key]);

    const orderChanged = typedKeys(tableState).some((key) => tableState[key] !== initialState['table'][key]);

    return filtersChanged || orderChanged;
  }
);
